import { RewardsFreeProductSchema } from "@apps/rewards/schemas/RewardsFreeProductSchemas/RewardsFreeProductSchema";
import { RewardsFreeProductVariantSchema } from "@apps/rewards/schemas/RewardsFreeProductSchemas/RewardsFreeProductVariantSchema";
import RewardsIconSchema from "@apps/rewards/schemas/RewardsIconSchema";
import {
    array,
    assign,
    boolean,
    enums,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { REWARDS_SPENDING_RULE_REDEEM_TYPES } from "../constants";

const RewardsSpendingRuleBaseSchema = object({
    id: number(),
    title: string(),
    pointsPrice: number(),
    icon: nullable(RewardsIconSchema),
});

const RewardsSpendingRuleDiscountExtraInfoSchema = object({
    discountExpirationInDays: nullable(number()),
    discountMinimumOrderAmount: nullable(number()),
});

export const RewardsSpendingRuleAmountDiscountSchema = assign(
    RewardsSpendingRuleBaseSchema,
    RewardsSpendingRuleDiscountExtraInfoSchema,
    object({
        type: literal("fixed_amount"),
        isFlexible: boolean(),
        discountValue: number(),
        minSpendablePoints: nullable(number()),
        maxSpendablePoints: nullable(number()),
    })
);

export const RewardsSpendingRulePercentageDiscountSchema = assign(
    RewardsSpendingRuleBaseSchema,
    RewardsSpendingRuleDiscountExtraInfoSchema,
    object({
        type: literal("percentage"),
        isFlexible: boolean(),
        discountValue: number(),
        minSpendablePoints: nullable(number()),
        maxSpendablePoints: nullable(number()),
    })
);

const RewardsSpendingRuleFreeShippingSchema = assign(
    RewardsSpendingRuleBaseSchema,
    RewardsSpendingRuleDiscountExtraInfoSchema,
    object({
        type: literal("free_shipping"),
    })
);

export const RewardsSpendingRuleFreeProductSchema = assign(
    RewardsSpendingRuleBaseSchema,
    RewardsFreeProductSchema,
    object({
        discountExpirationInDays: nullable(number()),
        pointsPrice: number(),
        variants: array(
            assign(RewardsFreeProductVariantSchema, object({ price: number() }))
        ),
    })
);

const RewardsSpendingRuleGiftCardSchema = assign(
    RewardsSpendingRuleBaseSchema,
    object({
        type: literal("gift_card"),
        giftCardValue: number(),
    })
);

export const RewardsSpendingRuleSchema = union([
    RewardsSpendingRuleAmountDiscountSchema,
    RewardsSpendingRulePercentageDiscountSchema,
    RewardsSpendingRuleFreeShippingSchema,
    RewardsSpendingRuleFreeProductSchema,
    RewardsSpendingRuleGiftCardSchema,
]);

export const RewardsSpendingRulesResponseSchema = object({
    rules: array(RewardsSpendingRuleSchema),
});

export const RewardsSpendingRulesRedeemResponseSchema = object({
    rewardType: enums(Object.values(REWARDS_SPENDING_RULE_REDEEM_TYPES)),
    rewardCode: string(),
});
